import { Attachment } from 'models/attachments.model'
import api from '../..'

export interface DownloadUsersOpts {
  disabled?: boolean
  areaIds?: number[]
}

const downloadUsers = ({ disabled, areaIds }: DownloadUsersOpts) => {
  const params: Record<string, unknown> = { disabled }
  if (areaIds?.length && areaIds[0] !== 0) {
    params.area_ids = areaIds
  }

  return api.get<string | Attachment>('administration/users/download', {
    params,
  })
}

export default downloadUsers
